import { CartAddEvent, CartErrorEvent } from '@theme/events';

let current = null;
function boot(carry, drawNow) {
  const root = document.getElementById('os-op'), dataEl = document.getElementById('os-op-data');

  if (root) document.querySelectorAll('[id$="__os_pdp_product_viewer"]').forEach((s) => s.remove());
  current = root && dataEl ? init(JSON.parse(dataEl.textContent), carry, drawNow) : null;
}

async function softGo(url, push, fresh) {
  const cur = current;
  if (!cur) { location.href = url; return; }
  try {
    const res = await fetch(url, { headers: { Accept: 'text/html' } });
    if (!res.ok) throw new Error('HTTP ' + res.status);
    const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
    const sec = cur.section, nsec = sec.id && doc.getElementById(sec.id);
    if (!nsec) throw new Error('section not in the fetched page');
    const picks = fresh ? undefined : cur.picks(), panelTop = document.getElementById('os-op').getBoundingClientRect().top;
    cur.teardown();
    sec.innerHTML = nsec.innerHTML;

    for (const el of document.querySelectorAll('.shopify-section[id^="shopify-section-template--"]')) {
      if (el === sec || /reviews/.test(el.id)) continue;
      const n = doc.getElementById(el.id); if (n) el.innerHTML = n.innerHTML;
    }
    document.title = doc.title;
    for (const sel of ['link[rel="canonical"]', 'meta[name="description"]', 'meta[property="og:title"]', 'meta[property="og:url"]', 'meta[property="og:image"]', 'meta[property="og:description"]']) {
      const a = document.head.querySelector(sel), b = doc.head.querySelector(sel); if (a && b) a.replaceWith(b.cloneNode(true));
    }
    if (push) history.pushState({ osop: url }, '', url);
    boot(picks, !fresh);
    const np = document.getElementById('os-op'); if (np) window.scrollBy({ top: np.getBoundingClientRect().top - panelTop, behavior: 'instant' });
  } catch (e) { location.href = url; }
}
history.replaceState(Object.assign({}, history.state, { osop: location.pathname }), '');
window.OS_OP = { softGo: (url) => softGo(url, true), get current() { return current; } };
window.addEventListener('popstate', (e) => { if (e.state && e.state.osop) softGo(e.state.osop, false); });
boot();

function init(D, carry, drawNow) {
  const root = document.getElementById('os-op');

  const FAM = D.fams[D.fam] || D.fams[Object.keys(D.fams)[0]], WORDS = FAM.words;
  D.lengths = FAM.lengths;
  D.leadTime = FAM.leadTime || '';

  const TFL_FINISHES = D.finishes, tflPremium = (name) => !!(TFL_FINISHES.find((x) => x.name === name) || {}).premium;
  if (FAM.finishes) D.finishes = D.finishes.filter((f) => FAM.finishes.includes(f.name)).map((f) => ({ ...f, premium: FAM.premium === false ? false : f.premium }));
  if (FAM.defaultFinish && D.finishes.some((f) => f.name === FAM.defaultFinish)) D.defaultFinish = FAM.defaultFinish;
  const money = (n) => '$' + Number(n).toLocaleString('en-US', { maximumFractionDigits: 0 });
  const money2 = (n) => '$' + Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const esc = (s) => String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
  const S = Object.assign({ ft: D.ft, finish: D.defaultFinish, side: D.defaultSide, grommet: 'none', gfinish: null, gqty: D.qty || 2, grot: 'across', plate: 'none', credenza: 'none', cfinish: null, cmetal: 'SV', cqty: 1, open: { color: true, side: true, grom: false, cred: false } }, carry || {}, { ft: D.ft });

  if (!D.finishes.some((f) => f.name === S.finish)) S.finish = D.defaultFinish;
  if (FAM.sidePanels === false || (S.side !== D.silverName && !D.finishes.some((f) => f.name === S.side))) S.side = D.defaultSide;
  const CQ_MAX = 3;
  const COUNT = ['', 'one', 'two', 'three'];

  const tone = (name) => { const f = D.finishes.find((x) => x.name === name); return f && f.tone && f.tone !== String(name).toLowerCase() ? `${name} (${f.tone})` : name; };
  const body = root.querySelector('[data-op-body]');
  const section = root.closest('.shopify-section') || document;
  const productForm = section.querySelector('product-form-component');

  const priceEl = section.querySelector('product-price'), ship = section.querySelector('.os-quick-ship-block');
  if (priceEl && ship && !priceEl.closest('.os-op__pricerow')) {
    const blk = ship.closest('.shopify-block'), dv = blk && blk.previousElementSibling;
    const pr = document.createElement('div'); pr.className = 'os-op__pricerow';
    priceEl.replaceWith(pr); pr.append(priceEl, ship);

    if (blk && !blk.contains(pr)) { blk.style.display = 'none'; if (dv && dv.classList.contains('divider')) dv.style.display = 'none'; }
  }

  const rating = section.querySelector('.os-pdp-rating'), prow = section.querySelector('.os-op__pricerow');
  if (rating && prow && !rating.querySelector('.os-pdp-rating__soon') && !prow.nextElementSibling?.classList.contains('os-pdp-rating')) {
    const rb = rating.closest('.shopify-block'); prow.after(rating); if (rb && !rb.querySelector('.os-pdp-rating')) rb.style.display = 'none';
  }

  const buyBlock = productForm && productForm.closest('.buy-buttons-block'), stickyBar = document.querySelector('.sticky-add-to-cart__bar');
  const cleanups = [];
  if (buyBlock && stickyBar && 'IntersectionObserver' in window) {
    let touched = !!carry, buyIn = true, priceIn = true;
    const priceRow = section.querySelector('.os-op__pricerow') || priceEl;
    const apply = () => { if (touched) stickyBar.dataset.stuck = !buyIn && !priceIn ? 'true' : 'false'; };

    const io = new IntersectionObserver((es) => { for (const e of es) { if (e.target === buyBlock) buyIn = e.isIntersecting; else priceIn = e.isIntersecting; } apply(); }, { rootMargin: '0px 0px 160px 0px' });
    const watch = () => { io.observe(buyBlock); if (priceRow) io.observe(priceRow); else priceIn = false; };
    watch(); cleanups.push(() => io.disconnect());
    root.addEventListener('pointerdown', () => { if (touched) return; touched = true; io.disconnect(); watch(); }, { passive: true });
  }

  const media = section.querySelector('.product-information__media media-gallery') || section.querySelector('.product-information__media');
  if (media && !media.querySelector('.os-op__more')) {
    const p = document.createElement('div'); p.className = 'os-op__more';
    p.innerHTML = '<div class="os-op__more-txt"><p class="os-op__more-t">Want more customization?</p><p class="os-op__more-s">More lengths, shapes, bases and finishes in our table builder.</p></div>' +
      '<a class="os-op__more-btn" href="/pages/build-your-own-conference-table">Build your own table <span aria-hidden="true">&rarr;</span></a>';
    media.appendChild(p);
  }

  const dimList = document.querySelector('.os-pdp-specs__dim-list'), L0 = D.lengths.find((x) => x.ft === D.ft);
  if (dimList && !dimList.dataset.opLabels && L0) {
    dimList.dataset.opLabels = '1';
    const tapers = !!(L0.tail && L0.tail !== L0.head);
    for (const li of dimList.querySelectorAll('li')) {
      const lab = li.querySelector('.dim-label'); if (!lab) continue; const t = lab.textContent.trim();
      if (t === 'Width') lab.textContent = 'Length';
      else if (t === 'Length') { lab.textContent = tapers ? 'Width at the head' : 'Width'; if (tapers) { const tl = li.cloneNode(true); tl.querySelector('.dim-label').textContent = 'Width at the tail'; tl.querySelector('.dim-value').textContent = `${L0.tail}"`; li.after(tl); } }
    }
  }

  const recs = document.querySelector('product-recommendations');
  if (recs && D.recId && String(recs.dataset.productId) !== String(D.recId)) {
    recs.dataset.productId = String(D.recId); delete recs.dataset.recommendationsPerformed;
    if (recs.querySelector('.product-grid, product-card, .card')) recs.replaceWith(recs);
  }
  const addon = (handle) => D.addons[handle] || { variants: [] };
  const variant = (handle, title) => addon(handle).variants.find((v) => v.title === title) || null;

  for (const g of D.grommets) {
    const vs = addon(g.handle).variants;
    if (vs.length) { g.finishes = Object.fromEntries(vs.map((v) => [v.title, v.price])); g.from = Math.min(...vs.map((v) => v.price)); if (g.finishes[g.default] == null) g.default = vs[0].title; }
  }
  for (const p of D.plates) p.price = addon(p.handle).variants[0] ? addon(p.handle).variants[0].price : 0;

  function plateChoices(q) {
    const [a, h] = D.plates, all = q === 1 ? '' : q === 2 ? ' in both' : ` in all ${COUNT[q] || q}`;
    const same = (p) => ({ key: p.key, label: p.label + all, inline: p.inline + all, parts: [[p.handle, q]], price: q * p.price });
    return [same(a), same(h)].concat(q === 2 ? [{ key: 'mix', label: 'One network, one HDMI', inline: 'one network, one HDMI', parts: [[a.handle, 1], [h.handle, 1]], price: a.price + h.price }] : []);
  }
  for (const c of D.credenzas) {
    const s = variant(c.handle, 'Standard finish'), pr = variant(c.handle, 'Premium finish');
    if (s) c.std = s.price; if (pr) c.prem = pr.price;
  }

  function calc() {
    const L = D.lengths.find((x) => x.ft === S.ft);
    const F = D.finishes.find((x) => x.name === S.finish);
    const prem = F.premium;
    const G = D.grommets.find((g) => g.key === S.grommet) || null;
    const gfin = G ? (S.gfinish && G.finishes[S.gfinish] != null ? S.gfinish : G.default) : null;

    const gmax = L.gmax || 2, rotDeg = S.grot === 'along' ? 0 : 90, rotWord = S.grot === 'along' ? 'along the table' : 'across the table';
    const spotsAt = (q) => (L.spots && L.spots[String(q)]) || {};
    const placed = (q) => !!(G && spotsAt(q)[`${G.key}@${rotDeg}`]);
    let qty = G ? Math.min(Math.max(1, S.gqty || 2), gmax) : 0;
    if (G && !placed(qty)) { const alt = Array.from({ length: gmax }, (_, i) => i + 1).filter(placed).sort((a, b) => Math.abs(a - qty) - Math.abs(b - qty))[0]; if (alt) qty = alt; }
    const spot = G ? spotsAt(qty)[`${G.key}@${rotDeg}`] || '' : '';
    const plateOpts = G && G.plates ? plateChoices(qty) : [];
    const P = plateOpts.find((p) => p.key === S.plate) || null;
    const C = D.credenzas.find((c) => c.key === S.credenza) || null;

    const cfin = S.cfinish || S.finish, cPrem = tflPremium(cfin);
    const premV = prem ? variant(D.premiumHandle, L.ft + ' ft') : null;

    const svpV = variant(D.silverHandle, L.ft + ' ft'), silver = S.side === D.silverName && !!svpV;

    const cq = C ? Math.min(Math.max(1, S.cqty || 1), CQ_MAX) : 0, cqWord = cq > 1 ? `${cq} × ` : '';

    const t = Number(D.pagePrice) > 0 ? Number(D.pagePrice) : L.std, pr = prem ? (premV ? premV.price : L.prem) : 0, sv = silver ? svpV.price : 0;
    const g = G ? qty * G.finishes[gfin] : 0, p = P ? P.price : 0, c = C ? cq * (cPrem ? C.prem : C.std) : 0;
    const lines = [[`Tenure ${L.ft} ft ${WORDS.line}`, money(t)]];
    if (pr) lines.push([`Premium color (${F.name})`, '+' + money(pr)]);
    if (silver) lines.push(['Silver metallic side panels', '+' + money(sv)]);
    if (G) lines.push([`${qty === 1 ? '1 power grommet' : `${qty} power grommets`}: ${G.label}, ${gfin}, ${rotWord}`, '+' + money(g)]);
    if (P) lines.push([`Connection plate${qty > 1 ? 's' : ''}: ${P.label}`, '+' + money(p)]);
    if (C) lines.push([`${cqWord}${C.label}, ${cfin}` + (S.cmetal === 'BK' ? ', black pulls' : ''), '+' + money(c)]);
    return { L, F, prem, G, gfin, qty, gmax, rotDeg, rotWord, spot, spotsAt, plateOpts, P, C, cq, cqWord, cfin, cPrem, premV, silver, svpV, total: t + pr + sv + g + p + c, lines };
  }

  const chevron = '<svg class="os-op__chev" width="14" height="14" viewBox="0 0 14 14" aria-hidden="true"><path d="M3 5l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.6"/></svg>';

  const swatch = (f, act, pressed, aria, cls = '') => `<button type="button" class="os-op__sw${f.premium ? ' os-op__sw--prem' : ''}${cls}" data-act="${act}" data-v="${esc(f.name)}" aria-pressed="${pressed}" aria-label="${esc(aria)}" title="${esc(aria)}">${f.swatch ? `<img src="${f.swatch}" alt="" width="36" height="36" loading="lazy">` : '<span></span>'}</button>`;
  const label = (what, name, more) => `<p class="os-op__label">${what}: <span>${esc(name)}${more ? ` <em>${esc(more)}</em>` : ''}</span></p>`;

  function swatches(r) {
    const add = money(r.premV ? r.premV.price : r.L.prem), more = r.prem ? `premium, +${add}` : '';
    const inner = `<div class="os-op__sws">${D.finishes.map((f) => swatch(f, 'finish', f.name === S.finish, f.name + (f.premium ? `, premium, +${add}` : ''))).join('')}</div>`;
    return row('color', 'Color', S.finish + (more ? ` ${more}` : ''), inner, esc(S.finish) + (more ? ` <em>${esc(more)}</em>` : ''));
  }

  function sidePanels(r) {
    const sv = r.svpV, metal = sv ? swatch({ name: D.silverName, premium: true }, 'side', S.side === D.silverName, `Side panels ${D.silverName}, +${money(sv.price)}`, ' os-op__sw--metal') : '';
    const more = r.silver ? `+${money(sv.price)}` : '';
    const inner = `<div class="os-op__sws">${D.finishes.map((f) => swatch({ ...f, premium: false }, 'side', f.name === S.side, `Side panels ${f.name}`)).join('')}${metal}</div>`;
    return row('side', 'Side panels', S.side + (more ? ` ${more}` : ''), inner, esc(S.side) + (more ? ` <em>${esc(more)}</em>` : ''));
  }

  function row(key, label, value, inner, valueHtml) {
    const open = S.open[key];
    return `<div class="os-op__row${open ? ' is-open' : ''}${value.length > 22 ? ' os-op__row--long' : ''}">
      <button type="button" class="os-op__rowbtn" data-act="toggle" data-v="${key}" aria-expanded="${open}" aria-controls="os-op-${key}">
        <span class="os-op__rowlbl">${label}</span><span class="os-op__rowval">${valueHtml || esc(value)}</span>${chevron}</button>
      <div class="os-op__rowbody" id="os-op-${key}"${open ? '' : ' hidden'}>${inner}</div></div>`;
  }

  function card(act, key, pressed, img, name, price, detailsKey) {
    return `<div class="os-op__card${pressed ? ' is-on' : ''}">
      <button type="button" class="os-op__cardpick" data-act="${act}" data-v="${key}" aria-pressed="${pressed}">
        ${img ? `<span class="os-op__cardimg"><img src="${img}" alt="" loading="lazy"></span>` : '<span class="os-op__cardimg os-op__cardimg--none"></span>'}
        <span class="os-op__cardname">${esc(name)}</span><span class="os-op__cardprice">${price}</span></button>
      ${detailsKey ? `<button type="button" class="os-op__details" data-act="details" data-v="${detailsKey}">Details</button>` : ''}</div>`;
  }

  const pill = (act, v, on, text) => `<button type="button" class="os-op__pill" data-act="${act}" data-v="${esc(v)}" aria-pressed="${on}">${text}</button>`;
  function grommetRow(r) {
    const n = r.qty || D.qty || 2;
    let inner = `<div class="os-op__cards">` + card('grommet', 'none', S.grommet === 'none', '', 'No grommets', 'Included', '') +
      D.grommets.map((g) => card('grommet', g.key, g.key === S.grommet, g.img, g.label, '+' + money(n * g.from), 'g:' + g.key)).join('') + `</div>`;
    if (r.G) {

      const counts = Array.from({ length: r.gmax }, (_, i) => i + 1).filter((q) => r.spotsAt(q)[`${r.G.key}@${r.rotDeg}`]);
      inner += `<div class="os-op__twin"><div class="os-op__pills os-op__pills--col"><span class="os-op__sub os-op__sub--head">How many</span><span class="os-op__pillrow">` + counts.map((q) => pill('gqty', q, q === r.qty, String(q))).join('') + `</span></div>` +
        `<div class="os-op__pills os-op__pills--col"><span class="os-op__sub os-op__sub--head">Which way</span><span class="os-op__pillrow">` + [['across', 'Across'], ['along', 'Along']].map(([k, t]) => pill('grot', k, k === S.grot, t)).join('') + `</span></div></div>`;
      inner += `<div class="os-op__pills"><span class="os-op__sub os-op__sub--head">Grommet finish</span>` + Object.keys(r.G.finishes).map((f) =>
        pill('gfinish', f, f === r.gfin, esc(f) + (r.G.finishes[f] > r.G.from ? ` +${money(r.qty * (r.G.finishes[f] - r.G.from))}` : ''))).join('') + `</div>`;
      if (r.G.plates) inner += `<div class="os-op__pills"><span class="os-op__sub os-op__sub--head">Connection plate${r.qty > 1 ? 's' : ''}, one fits each grommet</span>` + [{ key: 'none', label: 'None', price: 0 }].concat(r.plateOpts).map((p) =>
        pill('plate', p.key, p.key === (r.P ? r.P.key : 'none'), esc(p.label) + (p.price ? ' +' + money(p.price) : ''))).join('') +
        `<button type="button" class="os-op__details os-op__details--inline" data-act="details" data-v="plates">About the plates</button></div>`;
    }
    const val = r.G ? `${r.qty} × ${r.G.short || r.G.label}, ${r.gfin}, ${S.grot}` + (r.P ? ' + plates' : '') : 'None selected';
    return row('grom', 'Power grommets', val, inner);
  }

  const czImg = (c, fin) => D.czPics[`${c.key}|${fin}`] || c.img;
  function credenzaRow(r) {
    const n = r.cq || 1;
    let inner = `<div class="os-op__cards">` + card('credenza', 'none', S.credenza === 'none', '', 'No credenza', 'Included', '') +
      D.credenzas.map((c) => card('credenza', c.key, c.key === S.credenza, czImg(c, r.cfin), c.label, '+' + money(n * (r.cPrem ? c.prem : c.std)), 'c:' + c.key)).join('') + `</div>`;
    if (r.C) {
      const add = money(n * (r.C.prem - r.C.std));
      inner += `<div class="os-op__group os-op__czcolor">${label('Credenza color', r.cfin, r.cPrem ? `premium, +${add}` : '')}
        <div class="os-op__sws"><button type="button" class="os-op__pill os-op__pill--sm" data-act="cmatch" data-v="1" aria-pressed="${!S.cfinish}">Match the table</button>${D.finishes.map((f) => swatch({ ...f, premium: tflPremium(f.name) }, 'cfinish', !!S.cfinish && f.name === r.cfin, `Credenza ${f.name}` + (tflPremium(f.name) ? `, premium, +${add}` : ''))).join('')}</div></div>`;

      inner += `<div class="os-op__twin"><div class="os-op__pills os-op__pills--col"><span class="os-op__sub os-op__sub--head">How many</span><span class="os-op__pillrow">` + Array.from({ length: CQ_MAX }, (_, i) => i + 1).map((q) => pill('cqty', q, q === r.cq, String(q))).join('') + `</span></div>` +
        `<div class="os-op__pills os-op__pills--col"><span class="os-op__sub os-op__sub--head">Door and drawer pulls</span><span class="os-op__pillrow">${[['SV', 'Silver nickel'], ['BK', 'Black']].map(([k, t]) => pill('cmetal', k, (S.cmetal || 'SV') === k, t)).join('')}</span></div></div>`;
    }
    return row('cred', 'Credenza', r.C ? `${r.cqWord}${r.C.short}, ${r.cfin}` + (S.cmetal === 'BK' ? ', black pulls' : '') : 'None selected', inner);
  }

  function summary(r) {
    return `<div class="os-op__sum">` + r.lines.map(([a, b]) => `<div class="os-op__line"><span>${esc(a)}</span><b>${b}</b></div>`).join('') +
      `<div class="os-op__line"><span>Curbside freight in the continental US</span><b>FREE</b></div>
      <div class="os-op__line os-op__line--tot"><span>Total</span><span>${money(r.total)}</span></div>
      <p class="os-op__err" data-op-err hidden></p></div>` +
      (D.quoteJs ? `<button type="button" class="os-op__see3d" data-act="see3d">See it in 3D</button>` : '') +
      (changed() ? `<button type="button" class="os-op__reset" data-act="reset">Reset options</button>` : '');
  }
  const changed = () => S.finish !== D.defaultFinish || S.side !== D.defaultSide || S.grommet !== 'none' || S.credenza !== 'none';

  const V = { used: false, failed: false, err: false, lost: 0, mod: null, loading: null, want: null, drawing: false };
  const trace = (ev, x) => { const T = (window.OS_OP_TRACE = window.OS_OP_TRACE || []); T.push(Object.assign({ t: Date.now() % 1e6, ev }, x || {})); if (T.length > 80) T.shift(); };
  const dpr = () => Math.min(window.devicePixelRatio || 1, 2);
  const loadModule = () => (V.mod = V.mod || import(D.v2d));
  function loadViewer() {
    if (!V.loading) V.loading = loadModule().then((m) => {
      if (!m.webglOK()) throw new Error('no WebGL');
      const v = m.createViewer();

      v.canvas.addEventListener('webglcontextlost', () => { V.loading = null; photoAgain(); if (++V.lost > 2) { V.failed = true; render(); return; } if (V.used) setTimeout(requestDraw, 500); }, { once: true });
      return v;
    });
    return V.loading;
  }

  (window.requestIdleCallback || ((f) => setTimeout(f, 2000)))(() => loadModule().catch(() => {}), { timeout: 5000 });
  for (const ev of ['pointerdown', 'focusin']) root.addEventListener(ev, () => loadViewer().catch(() => {}), { once: true, passive: true });

  const mainSlide0 = section.querySelector('media-gallery slideshow-slide.product-media-container');
  const zoomLi0 = section.querySelector('media-gallery zoom-dialog li.product-media-container');
  const drawn = () => [
    mainSlide0 && mainSlide0.isConnected ? mainSlide0 : section.querySelector('media-gallery slideshow-slide.product-media-container'),
    zoomLi0 && zoomLi0.isConnected ? zoomLi0 : section.querySelector('media-gallery zoom-dialog li.product-media-container'),
  ].filter(Boolean);
  const copies = () => [
    section.querySelector('media-gallery .slideshow-controls__thumbnail'),
    section.querySelector('media-gallery zoom-dialog .dialog-thumbnails-list__thumbnail'),
  ].filter(Boolean);
  const targets = () => drawn().concat(copies());

  const sized = new ResizeObserver((es) => { if (V.used && !V.failed && es.some((e) => e.target.clientWidth)) requestDraw(); });

  function stageOf(t) {
    const zoom = t.tagName === 'LI', host = (zoom && t.querySelector('.product-media')) || t;
    let o = host.querySelector(':scope > .os-op__stage');
    trace('stage', { host: host.tagName + '.' + String(host.className).trim().split(/\s+/).slice(0, 2).join('.'), hostH: host.clientHeight, hostHidden: host.getAttribute('aria-hidden'), par: host.parentElement && host.parentElement.tagName, found: !!o, kids: [...host.children].map((c) => c.tagName + '.' + String(c.className).trim().split(/\s+/)[0]).join(',') });
    if (!o) {
      o = document.createElement('div'); o.className = 'os-op__stage' + (zoom ? ' os-op__stage--zoom' : ''); o.setAttribute('aria-hidden', 'true');
      o.appendChild(document.createElement('canvas')); host.appendChild(o);
      if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
      sized.observe(host);
    }
    if (zoom) {
      const im = host.querySelector('img');
      if (im) { sized.observe(im); const ok = im.offsetWidth > 0 && im.offsetHeight > 0; o.style.left = (ok ? im.offsetLeft : 0) + 'px'; o.style.top = (ok ? im.offsetTop : 0) + 'px'; o.style.width = (ok ? im.offsetWidth : 0) + 'px'; o.style.height = (ok ? im.offsetHeight : 0) + 'px'; }
    }
    return o;
  }
  const stageIn = (t) => t.querySelector('.os-op__stage');
  function pictureState(r) {
    return { fam: D.fam, ft: r.L.ft, finish: r.F.name, sideFinish: r.silver ? '' : S.side, sideMetal: r.silver, grommet: r.G ? r.G.key : '', gfinish: r.gfin || '', qty: r.G ? r.qty : 0, rot: r.G ? S.grot : '', credenza: r.C ? r.C.key : '', cfinish: r.C ? r.cfin : '', cmetal: r.C ? (S.cmetal || 'SV') : '', cqty: r.C ? r.cq : 0 };
  }
  function requestDraw() { V.want = pictureState(calc()); trace('want', { finish: V.want.finish, drawing: V.drawing }); if (!V.drawing) pump(); }
  function showSlideOne() {
    const sl = section.querySelector('media-gallery slideshow-component');
    if (sl && typeof sl.select === 'function' && sl.current !== 0) { try { sl.select(0, undefined, { animate: true }); } catch (e) {   } }
  }
  const photoAgain = () => targets().forEach((t) => { stageIn(t)?.remove(); const im = t.querySelector('img'); if (im && im.dataset.opAlt != null) im.alt = im.dataset.opAlt; });
  async function pump() {
    V.drawing = true;
    const main = targets()[0], busy = setTimeout(() => main && stageOf(main).classList.add('is-busy'), 250);
    if (!V.loading) loadViewer().catch(() => {});
    const mine = V.loading;
    let viewer;
    try { viewer = await mine; }
    catch (e) { clearTimeout(busy); V.failed = true; photoAgain(); V.drawing = false; render(); return; }
    try {
      while (V.want && !V.dead) {
        const s = V.want; V.want = null;
        for (const t of drawn()) {
          if (V.dead) break;
          if (V.loading !== mine) { V.want = s; break; }
          const o = stageOf(t), w = o.clientWidth, h = o.clientHeight, key = JSON.stringify(s);
          trace('target', { tag: t.tagName, w, h, drawn: (o.dataset.drawn || '').slice(0, 40), finish: s.finish });
          if (!w || !h) continue;

          const mul = o.classList.contains('os-op__stage--zoom') ? Math.min(2, Math.sqrt(5e6 / (w * h * dpr() * dpr()))) : 1;
          const W = Math.round(w * dpr() * mul), H = Math.round(h * dpr() * mul), c = o.firstChild;
          if (o.dataset.drawn === key && o.dataset.size === `${W}x${H}`) continue;
          let frame;
          try { frame = await viewer.draw(s, W, H); trace('drew', { finish: s.finish, W, H, newer: !!V.want }); }
          catch (e) { trace('drawerr', { msg: String(e && e.message).slice(0, 80) }); clearTimeout(busy); V.err = true; photoAgain(); render(); V.want = null; break; }
          V.err = false;
          if (V.dead) break;
          if (V.loading !== mine) { V.want = s; break; }
          if (V.want) break;
          if (c.width !== W || c.height !== H) { c.width = W; c.height = H; }
          c.getContext('2d').drawImage(frame, 0, 0);
          o.dataset.drawn = key; o.dataset.size = `${W}x${H}`; o.classList.add('is-ready');
          const im = t.querySelector('img');
          if (im) { if (!im.dataset.opAlt) im.dataset.opAlt = im.alt || ''; im.alt = `Tenure ${s.ft} ft ${WORDS.name} in ${tone(s.finish)}` + (s.sideMetal ? ', silver metallic side panels' : s.sideFinish && s.sideFinish !== s.finish ? `, ${tone(s.sideFinish)} side panels` : '') + (s.grommet ? `, ${COUNT[s.qty] || s.qty} power grommet${s.qty === 1 ? '' : 's'}` : '') + (s.credenza ? (s.cqty > 1 ? `, with ${COUNT[s.cqty] || s.cqty} credenzas in ${tone(s.cfinish)}` : `, with a credenza in ${tone(s.cfinish)}`) : ''); }
        }
        if (V.loading !== mine) break;
        const m = drawn()[0] && stageOf(drawn()[0]);
        if (!V.want && m && m.classList.contains('is-ready')) for (const t of copies()) {
          const o = stageOf(t), W = Math.round(o.clientWidth * dpr()), H = Math.round(o.clientHeight * dpr()), c = o.firstChild, src = m.firstChild;
          if (!W || !H || (o.dataset.drawn === m.dataset.drawn && o.dataset.size === `${W}x${H}`)) continue;
          if (c.width !== W || c.height !== H) { c.width = W; c.height = H; }
          const k = Math.min(W / src.width, H / src.height), g = c.getContext('2d');
          g.fillStyle = '#fff'; g.fillRect(0, 0, W, H); g.imageSmoothingQuality = 'high';
          g.drawImage(src, (W - src.width * k) / 2, (H - src.height * k) / 2, src.width * k, src.height * k);
          o.dataset.drawn = m.dataset.drawn; o.dataset.size = `${W}x${H}`; o.classList.add('is-ready');
        }
      }
    } finally {
      trace('pump-end', { want: !!V.want });
      clearTimeout(busy); if (!V.dead) targets().forEach((t) => stageIn(t)?.classList.remove('is-busy')); V.drawing = false;
      if (V.want && !V.failed && !V.dead) pump();
    }
  }
  function paintStage() { if (V.used && !V.failed) requestDraw(); }

  function paintPrice(r) {
    section.querySelectorAll('product-price .money, .sticky-add-to-cart .price .money').forEach((m) => { m.textContent = money2(r.total); });
    const h1 = section.querySelector('h1');
    if (h1 && S.ft !== D.ft) h1.textContent = r.L.title; else if (h1 && D.pageTitle) h1.textContent = D.pageTitle;
  }

  function render() {
    const r = calc();
    const focusKey = document.activeElement && root.contains(document.activeElement) ? document.activeElement.dataset.act + '|' + document.activeElement.dataset.v : null;
    body.innerHTML = swatches(r) + (FAM.sidePanels === false ? '' : sidePanels(r)) + grommetRow(r) + credenzaRow(r) + summary(r) +
      ((V.failed || V.err) && V.used ? `<p class="os-op__note">The picture shows the table in ${esc(D.defaultFinish)} with two power grommets. Yours is made with the options you pick.</p>` : '');
    root.querySelectorAll('[data-act="size"]').forEach((a) => a.setAttribute('aria-current', String(Number(a.dataset.v) === S.ft)));
    if (focusKey) { const [a, v] = focusKey.split('|'); const el = body.querySelector(`[data-act="${a}"][data-v="${CSS.escape(v)}"]`); if (el) el.focus(); }
    paintStage(); paintPrice(r);
  }

  const dlg = document.createElement('dialog'); dlg.className = 'os-op__dlg'; dlg.setAttribute('aria-labelledby', 'os-op-dlg-t');
  document.body.appendChild(dlg);
  function details(key) {
    let h = '';
    if (key.startsWith('g:')) {
      const g = D.grommets.find((x) => x.key === key.slice(2));
      h = `<img src="${g.img}" alt="${esc(g.label)} power grommet" class="os-op__dlgimg"><h2 id="os-op-dlg-t">${esc(g.label)}</h2><p>${esc(g.summary)}</p>
        <ul>${g.specs.map((s) => `<li>${esc(s)}</li>`).join('')}</ul>
        <p class="os-op__sub">Finishes, each: ${Object.keys(g.finishes).map((n) => `${esc(n)} ${money(g.finishes[n])}`).join(' · ')}</p>
        <button type="button" class="os-op__choose" data-act="grommet" data-v="${g.key}">Choose this grommet</button>`;
    } else if (key.startsWith('c:')) {
      const c = D.credenzas.find((x) => x.key === key.slice(2)), r = calc();
      h = `<img src="${czImg(c, r.cfin)}" alt="${esc(c.label)} in ${esc(tone(r.cfin))}" class="os-op__dlgimg"><h2 id="os-op-dlg-t">${esc(c.label)}</h2><p>${esc(c.summary)}</p>
        <ul>${c.specs.map((s) => `<li>${esc(s)}</li>`).join('')}</ul><p class="os-op__sub">${money(r.cPrem ? c.prem : c.std)}${r.cq > 1 ? ' each' : ''} in ${esc(r.cfin)}${S.cfinish ? '' : ', to match your table'}</p>
        <button type="button" class="os-op__choose" data-act="credenza" data-v="${c.key}">Choose this credenza</button>`;
    } else if (key === 'plates') {
      h = `<h2 id="os-op-dlg-t">Connection plates</h2><p>The 2-outlet and 6-outlet grommets have a slot for one plate each.</p>
        <ul>${D.plateInfo.map((p) => `<li><b>${esc(p.label)}:</b> ${esc(p.text)}</li>`).join('')}</ul>`;
    }
    dlg.innerHTML = `<button type="button" class="os-op__close" data-act="close" aria-label="Close">×</button>` + h;
    dlg.showModal();
  }
  dlg.addEventListener('click', (e) => {
    if (e.target === dlg) { dlg.close(); return; }
    const b = e.target.closest('[data-act]'); if (!b) return;
    if (b.dataset.act !== 'close') act(b.dataset.act, b.dataset.v);
    dlg.close();
  });

  const HOOK_URL = 'https://officesimpli.app.n8n.cloud/webhook/os-builder', SALES_EMAIL = 'sales@officesimpli.com';
  const tableQty = () => Math.max(1, Number((productForm && productForm.querySelector('[name="quantity"]') || {}).value) || 1);
  const quoteText = (r, q) => `${q > 1 ? q + ' tables: ' : ''}Tenure ${r.L.ft} ft ${WORDS.name}\n` + r.lines.map(([a, b]) => `${a}: ${b}`).join('\n') +
    `\nCurbside freight in the continental US: FREE\nTotal: ${money(r.total)}${q > 1 ? ' each' : ''}\n${location.origin}${location.pathname}`;
  const vid = () => { try { const k = 'os_builder_vid'; let v = localStorage.getItem(k); if (!v) { v = Math.random().toString(36).slice(2, 10) + Date.now().toString(36); localStorage.setItem(k, v); } return v; } catch (e) { return 'na'; } };
  function quoteDialog() {
    const r = calc(), q = tableQty(), txt = quoteText(r, q);
    const mailto = `mailto:${SALES_EMAIL}?subject=${encodeURIComponent('Conference table quote request: Tenure ' + r.L.ft + ' ft ' + WORDS.line)}&body=${encodeURIComponent(txt + '\n\nName:\nPhone:\nCompany:\nDelivery ZIP code:\nBusiness or home address:\nPaying by (card, or invoice / purchase order):\n')}`;
    dlg.innerHTML = `<button type="button" class="os-op__close" data-act="close" aria-label="Close">×</button><h2 id="os-op-dlg-t">Request a quote for this configuration</h2>
      <pre class="os-op__qcfg">${esc(txt)}</pre>
      <form class="os-op__qform" novalidate>
        <label>Name<input name="name" required autocomplete="name"></label>
        <label>Email<input name="email" type="email" required autocomplete="email"></label>
        <label>Phone<input name="phone" type="tel" autocomplete="tel"></label>
        <label>Company<input name="company" autocomplete="organization"></label>
        <label>Delivery ZIP code<input name="zip" required inputmode="numeric" autocomplete="postal-code"></label>
        <fieldset class="os-op__qset"><legend>Delivery address</legend><label class="os-op__qradio"><input type="radio" name="address" value="business" checked> Business</label><label class="os-op__qradio"><input type="radio" name="address" value="home"> Home</label></fieldset>
        <fieldset class="os-op__qset"><legend>Paying by</legend><label class="os-op__qradio"><input type="radio" name="pay" value="card" checked> Card</label><label class="os-op__qradio"><input type="radio" name="pay" value="invoice"> Invoice or purchase order</label></fieldset>
        <label>Anything else<textarea name="notes" rows="3" maxlength="600"></textarea></label>
        <p class="os-op__err" data-q-err hidden></p>
        <button type="submit" class="os-op__choose">Send</button>
        <p class="os-op__sub">We email you the quote, usually within one business day. Or write to <a href="${mailto}">${SALES_EMAIL}</a>.</p>
      </form>`;
    dlg.showModal();
    const form = dlg.querySelector('form');
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const err = form.querySelector('[data-q-err]');
      if (!form.checkValidity()) { err.textContent = 'Please add your name, email and delivery ZIP code.'; err.hidden = false; (form.querySelector(':invalid') || {}).focus?.(); return; }
      const d = Object.fromEntries(new FormData(form)), btn = form.querySelector('[type="submit"]'); btn.disabled = true; btn.textContent = 'Sending...';
      const qs = new URLSearchParams(location.search), track = {};
      for (const k of ['gclid', 'gbraid', 'wbraid', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content']) if (qs.get(k)) track[k] = qs.get(k).slice(0, 200);

      const onPreview = !!(window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main');
      const test = qs.get('ostest') === '1' || !!navigator.webdriver || onPreview;
      const lead = { event: 'lead', source: 'pdp-panel', test, ...d, qty: q, title: `Tenure ${r.L.ft} ft ${WORDS.name} (product page)`, total: Math.round(r.total * q), per_table: Math.round(r.total),
        shipping: 'included', untouched: false, link: location.origin + location.pathname, config: txt, parts: r.lines.map(([a, b]) => ({ sku: '', desc: a, qty: 1, price: Number(String(b).replace(/[^\d.]/g, '')) || 0 })),
        vid: vid(), ts: new Date().toISOString(), page: location.pathname, preview: onPreview, ref: document.referrer || '', ...track, src: 'pdp' };
      let ok = false;
      try { const res = await fetch(HOOK_URL, { method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify(lead), mode: 'cors', credentials: 'omit' }); ok = res.ok; } catch (e2) { ok = false; }
      if (ok) form.innerHTML = `<p class="os-op__qsent">Sent. We will email your quote to ${esc(d.email)}, usually within one business day.</p><button type="button" class="os-op__choose" data-act="close">Close</button>`;
      else { btn.disabled = false; btn.textContent = 'Send'; err.innerHTML = `Something went wrong sending this. Please <a href="${mailto}">email it to us instead</a>: the email opens with your configuration filled in.`; err.hidden = false; }
    });
  }
  if (buyBlock && !section.querySelector('.os-op__quote')) {
    const b = document.createElement('button'); b.type = 'button'; b.className = 'os-op__quote'; b.textContent = 'Request a quote for this configuration';
    b.addEventListener('click', () => { if (D.quoteJs) import(D.quoteJs).then((m) => m.open(current)).catch(quoteDialog); else quoteDialog(); }); buyBlock.after(b);
  }

  const PICTURE = new Set(['finish', 'side', 'grommet', 'gfinish', 'gqty', 'grot', 'size', 'credenza', 'cfinish', 'cmatch', 'cmetal', 'cqty']);
  function act(a, v) {
    if (PICTURE.has(a)) { V.used = true; showSlideOne(); }
    if (a === 'finish') { S.finish = v; if (S.cfinish === v) S.cfinish = null; }
    else if (a === 'side') S.side = v;
    else if (a === 'toggle') S.open[v] = !S.open[v];
    else if (a === 'grommet') Object.assign(S, { grommet: v, gfinish: null, plate: 'none' }), (S.open.grom = true);
    else if (a === 'gfinish') S.gfinish = v;
    else if (a === 'gqty') { S.gqty = Number(v); if (S.plate === 'mix' && S.gqty !== 2) S.plate = 'none'; }
    else if (a === 'grot') S.grot = v;
    else if (a === 'plate') S.plate = v;
    else if (a === 'credenza') S.credenza = v, (S.open.cred = true);
    else if (a === 'cfinish') S.cfinish = v === S.finish ? null : v;
    else if (a === 'cmatch') S.cfinish = null;
    else if (a === 'cmetal') S.cmetal = v;
    else if (a === 'cqty') S.cqty = Math.min(Math.max(1, Number(v) || 1), CQ_MAX);
    else if (a === 'details') { details(v); return; }
    else if (a === 'size') S.ft = Number(v);
    render();
  }
  root.addEventListener('click', (e) => {
    const b = e.target.closest('[data-act]'); if (!b) return;
    if (b.dataset.act === 'size') { const L = D.lengths.find((x) => x.ft === Number(b.dataset.v)); e.preventDefault(); if (L && L.url && L.ft !== D.ft) { softGo(L.url, true); return; } }

    if (b.dataset.act === 'depth') { e.preventDefault(); if (b.getAttribute('aria-current') !== 'page') softGo(b.getAttribute('href'), true); return; }
    if (b.dataset.act === 'reset') { softGo(location.href, false, true); return; }

    if (b.dataset.act === 'see3d') { e.preventDefault(); if (D.quoteJs) import(D.quoteJs).then((m) => m.open(current)).catch(() => {}); return; }
    act(b.dataset.act, b.dataset.v);
  });

  function cartItems(r, q) {
    const forTable = `Tenure ${r.L.ft} ft ${WORDS.name}`;
    const tableV = productForm && productForm.querySelector('form [name="id"]');
    const props = { Color: S.finish, 'Side panels': S.side };
    if (r.G) props['Power grommets'] = `${r.qty} × ${r.G.label} (${r.gfin}), ${r.rotWord}` + (r.P ? `, ${r.P.inline}` : '') + (r.spot ? `; ${r.spot}` : '');
    if (r.C) props.Credenza = `${r.cqWord}${r.C.short} (${r.cfin})` + (S.cmetal === 'BK' ? ', black pulls' : ', silver nickel pulls');
    const items = [{ id: Number(tableV && tableV.value), quantity: q, properties: props }];
    const sub = { _For: forTable };

    const need = (v) => (v ? v.id : 0);
    if (r.prem) items.push({ id: need(r.premV), quantity: q, properties: sub });
    if (r.silver) items.push({ id: need(r.svpV), quantity: q, properties: sub });
    if (r.G) items.push({ id: need(variant(r.G.handle, r.gfin)), quantity: r.qty * q, properties: sub });
    if (r.P) for (const [h, n] of r.P.parts) items.push({ id: need(addon(h).variants[0]), quantity: n * q, properties: sub });
    if (r.C) items.push({ id: need(variant(r.C.handle, r.cPrem ? 'Premium finish' : 'Standard finish')), quantity: r.cq * q, properties: { ...sub, Color: r.cfin, Pulls: S.cmetal === 'BK' ? 'Black' : 'Silver nickel' } });
    return items;
  }
  function showErr(msg) { const el = root.querySelector('[data-op-err]'); if (el) { el.textContent = msg; el.hidden = false; } }

  const onSubmit = (e) => {
    const form = e.target;
    if (!productForm || !productForm.contains(form)) return;
    e.preventDefault(); e.stopImmediatePropagation();
    const r = calc();
    const L = D.lengths.find((x) => x.ft === S.ft);
    if (S.ft !== D.ft) { showErr(`The ${L.ft} ft page is not built yet. In this preview, add to cart works on the ${D.ft} ft table.`); return; }
    const q = Math.max(1, Number((productForm.querySelector('[name="quantity"]') || {}).value) || 1);
    const items = cartItems(r, q);
    if (items.some((i) => !i.id)) { showErr('Something went wrong adding this to the cart. Please try again, or contact us and we will sort it out.'); return; }
    const ids = [...document.querySelectorAll('cart-items-component')].map((c) => c.dataset.sectionId).filter(Boolean);
    fetch((window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items, sections: ids.join(',') }),
    }).then((res) => res.json()).then((res) => {
      if (res.status) { productForm.dispatchEvent(new CartErrorEvent(productForm.id, res.message, res.description, res.errors)); showErr(res.description || res.message); return; }
      productForm.dispatchEvent(new CartAddEvent({}, String(items[0].id), { source: 'product-form-component', itemCount: items.reduce((a, i) => a + i.quantity, 0), productId: productForm.dataset.productId, sections: res.sections }));
    }).catch(() => showErr('Something went wrong adding this to the cart. Please try again.'));
  };
  window.addEventListener('submit', onSubmit, true); cleanups.push(() => window.removeEventListener('submit', onSubmit, true));
  cleanups.push(() => { V.dead = true; V.want = null; sized.disconnect(); dlg.remove(); const mine = V.loading; if (mine) mine.then((v) => { try { v.renderer.forceContextLoss(); v.renderer.dispose(); } catch (e) {   } }).catch(() => {}); });

  render();

  const pictureChanged = !!carry && (S.finish !== D.defaultFinish || S.side !== D.defaultSide || S.grommet !== 'none' || S.credenza !== 'none');
  if (drawNow && pictureChanged) { V.used = true; requestDraw(); }

  function quote() {
    const r = calc(), q = tableQty(), legs = FAM.legs || null;
    return { fam: D.fam, ft: S.ft, head: r.L.head, tail: r.L.tail, depth: FAM.depth, sku: D.sku || null, title: r.L.title || D.pageTitle || document.title, words: WORDS, qty: q,
      lines: r.lines.map(([a, b]) => ({ label: a, amount: b })), total: r.total, picture: pictureState(r),
      finish: S.finish, side: FAM.sidePanels === false ? null : (r.silver ? D.silverName : S.side), silver: r.silver, legs, baseColor: legs ? `${legs} metal legs` : S.finish,
      grommets: r.G ? { label: r.G.label, qty: r.qty, finish: r.gfin, rot: r.rotWord, plate: r.P ? r.P.inline : null, spot: r.spot } : null,
      credenzas: r.C ? { label: r.C.label, qty: r.cq, finish: r.cfin, pulls: S.cmetal === 'BK' ? 'Black' : 'Silver nickel' } : null,
      leadTime: D.leadTime || '', url: location.origin + location.pathname, config: quoteText(r, q), cart: cartItems(r, q) };
  }
  const isTest = () => { const qs = new URLSearchParams(location.search); const onPreview = !!(window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main'); return qs.get('ostest') === '1' || !!navigator.webdriver || onPreview; };

  return { section, picks: () => ({ ...(S.finish !== D.defaultFinish ? { finish: S.finish } : {}), ...(S.side !== D.defaultSide ? { side: S.side } : {}), grommet: S.grommet, gfinish: S.gfinish, gqty: S.gqty, grot: S.grot, plate: S.plate, credenza: S.credenza, cfinish: S.cfinish, cmetal: S.cmetal, cqty: S.cqty, open: Object.assign({}, S.open) }), teardown: () => cleanups.splice(0).forEach((f) => { try { f(); } catch (e) {   } }),
    quote, viewer: () => loadViewer(), vid, isTest, requestQuote: quoteDialog };
}
